import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createContentItem as createContentItemAPI } from '@/api/v4/content-items.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';

export const useCreateContentItem = () => {
  const { t } = useTranslation('feed');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createContentItemAPI,
    onSuccess: async data => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ContentItems] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.FeedContentItems],
        }),
      ]);
      notify({
        message: t`createSuccess`,
      });
      return data;
    },
    onError: () => {
      notify({
        message: t`createError`,
      });
    },
  });

  return {
    createContentItem: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
